import "./Home.scss";

import { Suspense, useCallback, useEffect, useState } from "react";

// import DemoRequest from "../../components/general/misc/DemoRequest";
import News from "./News";
import Products from "./Products";
import SocialNetworks from "./SoacialNetworks";
import { withRouter } from "react-router";
import BrainButtons from "../../components/home/BrainButtons";
import ScrollDown from "../../components/general/background/ScrollDownIcon";

const Home = (props) => {
  const [isFocusTab, toggleIsFocusTab] = useState(true);
  const [isLoadedBrain, toggleIsLoadedBrain] = useState(false);

  const onFocus = useCallback(() => {
    if (!isLoadedBrain) {
      toggleIsFocusTab(true);
    }
  }, [isLoadedBrain, toggleIsFocusTab]);

  const onBlur = useCallback(() => {
    if (!isLoadedBrain) {
      toggleIsFocusTab(false);
    }
  }, [isLoadedBrain, toggleIsFocusTab]);

  useEffect(() => {
    window.addEventListener("focus", onFocus);
    window.addEventListener("blur", onBlur);
    return () => {
      window.removeEventListener("focus", onFocus);
      window.removeEventListener("blur", onBlur);
    };
  });

  useEffect(() => {
    if (isLoadedBrain) {
      window.removeEventListener("focus", onFocus);
      window.removeEventListener("blur", onBlur);
    }
  }, [isLoadedBrain, onFocus, onBlur]);

  return (
    <div className="home__container">
      <SocialNetworks />
      <div
        className="brain_home"
        onDoubleClick={withRouter(() =>
          window.innerWidth < 768 ? props.history.push("/products") : {}
        )}
      >
        {isFocusTab && (
          <Suspense fallback={<></>}>
            <BrainButtons onMounted={() => toggleIsLoadedBrain(true)} />
          </Suspense>
        )}
      </div>
      <Products />
      {/* <DemoRequest expanded={true} /> */}
      <News />
      {window.innerWidth < 700 && (
        <span>
          <ScrollDown />
        </span>
      )}
    </div>
  );
};

export default Home;
